// extracted by mini-css-extract-plugin
export default {"header":"AppLayout_header__bR3TJ","app-title":"AppLayout_app-title__smcw6","app-subtitle":"AppLayout_app-subtitle__9BMLz"};